export function FloppyIcon() {
    return <svg className={'multi-color'} width="128" height="128" viewBox="0 0 128 128"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                role="img">
        <path className="housing" fill="#838383"
              d="M124.17 27.95v87.49c0 4.82-3.91 8.73-8.73 8.73H12.56c-4.82 0-8.73-3.91-8.73-8.73V12.56c0-4.82 3.91-8.73 8.73-8.73h89.64c3.56 0 6.94 1.59 9.21 4.34l10.04 12.19c1.76 2.14 2.72 4.82 2.72 7.59z"/>
        <path className="label-part-1" fill="#ffffff"
              d="M103.94 124.17H24V71.25c0-1.81 1.47-3.28 3.28-3.28h73.39c1.81 0 3.28 1.47 3.28 3.28v52.92z"/>
        <path className='label-part-2' fill="#039be5" d="M24 111.92h79.94v12.25H24z"/>
        <path className="rails" fill="#5d5d5d"
              d="M16.75 3.83v47.75c0 1.78 1.57 3.17 3.65 3.17h76.65c2.08 0 3.69-1.38 3.69-3.17V3.83H16.75z"/>
        <path className='door' fill="#e0e0e0"
              d="M35 3.83v45.02c0 1.68 1.18 2.98 2.74 2.98H95.2c1.56 0 2.77-1.3 2.77-2.98V3.83H35zm50.97 42.69c0 .72-.59 1.31-1.31 1.31H67.28c-.72 0-1.31-.59-1.31-1.31V9.14c0-.72.59-1.31 1.31-1.31h17.38c.72 0 1.31.59 1.31 1.31v37.38z"/>
    </svg>;
}
